export var FetchOrdersPageType;
(function (FetchOrdersPageType) {
    FetchOrdersPageType["ITINERARY"] = "itinerary";
    FetchOrdersPageType["ORDERS"] = "orders";
    FetchOrdersPageType["VISITS"] = "visits";
})(FetchOrdersPageType || (FetchOrdersPageType = {}));
//# sourceMappingURL=orders.js.map